export default {
  name: "card",
  computed: {
    cardWidth() {
      let cardWidth = null;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          cardWidth = "calc(95vw - 16px)";
          break;
        case "md":
          cardWidth = "calc(65vw)";
          break;
        case "lg":
          cardWidth = "calc(400px)";
          break;
        case "xl":
          cardWidth = "calc(400px + 8vw)";
          break;
        default:
          break;
      }
      return cardWidth;
    },
    cardHeight() {
      return "fit-content";
    },
  },
};
